import React from 'react'

interface Props {
  testid: string
  [x: string]: any
}

export interface FieldProps {
  value: string
  onChange(value: any): void
  onBlur(value?: any): void
}

export const fieldAdapter = (Component: any) => (props: Props) => {
  const localProps = {
    ...props,
    ...props.input,
  }
  delete localProps.meta
  delete localProps.input
  if (props.meta && props.meta.error && props.meta.touched) {
    if (!localProps.messages) {
      localProps.messages = {}
    }
    localProps.messages.error = props.meta.error
  }
  return <Component {...localProps} />
}
